import { useAuth } from "@/store/auth";
import { getDefaultRouteAfterLogin } from "@/utils/validations/permissions";
import { Navigate, Outlet, useLocation } from "react-router-dom";

const PublicRoute = () => {
  const { isAuth, isCommercial, role, user, isLoadingAuth, authMethod, twoFACompleted } = useAuth();
  const { pathname } = useLocation();

  if (isAuth) {
    if (!user?.id) {
      return null;
    }

    if (isLoadingAuth) {
      return null;
    }

    // Gate navigation until 2FA is completed when required
    if (user?.has2FA && authMethod && !twoFACompleted) {
      return <Outlet />;
    }

    const redirectTo = getDefaultRouteAfterLogin(isCommercial, role, user?.features);

    return <Navigate to={redirectTo} state={{ from: pathname }} replace />;
  }

  return <Outlet />;
};

export default PublicRoute;
